import { useEffect, useState } from "react";
import api from "../services/api";
import { useAuth } from "../context/AuthContext";

export function useClients() {
  const { token } = useAuth();
  const [clients, setClients] = useState<any[]>([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.get("/clients?search=", {
          headers: { Authorization: `Bearer ${token}` }
        });
        setClients(res.data);
      } catch {
        setClients([]);
      }
    };
    fetch();
  }, [token]);

  return clients;
}
